<i18n src="@/lang/protocols.yaml"></i18n>

<template lang="pug">
.tab-pane.card-body
    h2.mb-4 {{ $t('tabs.schutzziel1.title') }}
    .row
        .col-md-4
            .card.border-success(v-if="validSchutzziel1")
                .card-body.text-center
                    font-awesome-icon.text-success.mb-4(icon="check-circle", size="4x")
                    p.mb-0(v-html="$t('tabs.schutzziel1.result.success', { rlv: protocol.rlvExtended.toFixed(2) })")
            .card.border-warning(v-else)
                .card-body.text-center
                    font-awesome-icon.text-warning.mb-4(icon="exclamation-circle", size="4x")
                    p.mb-0(v-if="!protocol.data.rooms[0].isVlr") {{ $t('tabs.schutzziel1.result.warningVlrMissing') }}
                    p.mb-0(v-else) {{ $t('tabs.schutzziel1.result.warningRlvInsufficient', { rlv: protocol.rlv.toFixed(2) }) }}

            button.btn.btn-block.mt-4(
                :disabled="!validSchutzziel1",
                :class="validSchutzziel1 ? 'btn-primary' : 'btn-secondary'",
                @click="saveAndContinue"
            ) Speichern &amp; Weiter

        .col
            p(v-if="protocol.rlv >= 1") {{ $t('tabs.schutzziel1.adjoiningRoom.notNecessary') }}

            .form-group.mt-4(v-else)
                label.label-title {{ $t('tabs.schutzziel1.adjoiningRoom.label') }}
                select.custom-select(v-model="adjoiningRoom")
                    option(:value="null", disabled) Bitte auswählen
                    option(:value="option.value", :disabled="option.disabled", v-for="option in adjoinableRooms") {{ option.text }}
                small.form-text.text-muted {{ $t('tabs.schutzziel1.adjoiningRoom.description') }}

            character-count-textarea(v-model="protocol.data.schutzziel1.description")
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCheckCircle, faExclamationCircle } from '@fortawesome/free-solid-svg-icons'
import CharacterCountTextarea from '@/components/CharacterCountTextarea'
import { Protocol } from 'trgi'

library.add(faCheckCircle, faExclamationCircle)

export default {
    components: {
        CharacterCountTextarea
    },
    props: {
        value: {
            type: Protocol,
            validator: function (value) {
                // Schutzziel 1 requires at least one room - do not show Tab, if there are no rooms
                return value.data.rooms.length >= 1
            },
            default: function () {
                return new Protocol()
            }
        }
    },
    data () {
        const protocol = new Protocol(this.value)
        return {
            protocol
        }
    },
    computed: {
        validSchutzziel1 () {
            return this.protocol.rlvExtended >= 1
        },
        adjoiningRoom: {
            get () {
                // Return Adjoining Room Index
                const idx = this.protocol.data.rooms.findIndex(room => room.isAdjoiningRoom)
                // Only, when it's not -1 (no adjoining room found) and not 0 (main room adjoined)
                return idx > 0 ? idx : null
            },
            set (idx) {
                // Reset All Rooms
                this.protocol.data.rooms = this.protocol.data.rooms.map(room => {
                    room.isAdjoiningRoom = false
                    return room
                })

                // Then Set Given Room as Adjoining Room
                if (!idx) {
                    return
                }
                this.protocol.data.rooms[idx].isAdjoiningRoom = true
            }
        },
        adjoinableRooms () {
            return this.protocol.data.rooms.map((room, index) => {
                let disabled = false
                let notice = ''
                if (index === 0) {
                    disabled = true
                    if (this.protocol.rlv < 1) notice = ' - Nicht ausreichend'
                    // TODO: Clarify this statement (Why is no Luftverbund possible?)
                    if (this.protocol.rlv === 0) notice = ' - Kein Luftverbund möglich'
                }
                return { value: index, disabled, text: room.name + ' (' + room.volume + 'm³)' + notice }
            })
        }
    },
    watch: {
        // When Protocol gets modified on another Tab, refresh Local Protocol Variable
        value (value) {
            this.protocol = new Protocol(value)
        },
        // When Local Protocol achieves a Valid Schutzziel 1, let the Parent View know
        validSchutzziel1 (value) {
            this.$emit('update', value)
        }
    },
    created () {
        this.$emit('update', this.validSchutzziel1)
    },
    methods: {
        saveAndContinue () {
            // If an Adjoining Room is actually not needed, unset it
            if (this.protocol.rlv >= 1) {
                this.adjoiningRoom = null
            }

            this.$emit('save', new Protocol(this.protocol))
        }
    }
}
</script>
